import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'

function Setting() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [inactive, setInactive] = useState(true)

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const res = await axios.get('https://trakersmallbusienss-3.onrender.com/api/auth/user', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })
        setName(res.data.name)
        setEmail(res.data.email)
      } catch (error) {
        console.error('Error fetching user info:', error)
        Swal.fire({
          icon: 'error',
          title: 'Failed to load user info',
        })
      }
    }

    fetchUserInfo()
  }, [])

  const validateInputs = () => {
    if (!name || !email) {
      Swal.fire({
        icon: 'warning',
        title: 'Both fields are required!',
      })
      return false
    }
    return true
  }

  const submitChanges = async () => {
    try {
      await axios.patch(
        'https://trakersmallbusienss-3.onrender.com/api/auth/Setting',
        { name, email },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      )

      Swal.fire({
        icon: 'success',
        title: 'Your Info was Edited!',
        showConfirmButton: false,
        timer: 1500,
      })

      setInactive(true)
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Failed to update info.',
      })
    }
  }

  const handlerSubmit = async (e) => {
    e.preventDefault()
    if (!validateInputs()) return
    await submitChanges()
  }

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-2xl shadow-lg">
      <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">Settings</h1>

      <form className="flex flex-col space-y-4" onSubmit={handlerSubmit}>
        <div>
          <label className="block mb-1 font-medium text-gray-700">Edit Your Name:</label>
          <input
            type="text"
            placeholder="Edit Your Name"
            onChange={(e) => setName(e.target.value)}
            value={name}
            readOnly={inactive}
            className={`w-full px-4 py-2 border ${
              inactive ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
            } border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400`}
          />
        </div>

        <div>
          <label className="block mb-1 font-medium text-gray-700">Edit Your Email:</label>
          <input
            type="email"
            placeholder="Edit Your Email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            readOnly={inactive}
            className={`w-full px-4 py-2 border ${
              inactive ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
            } border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400`}
          />
        </div>

        <div className="flex justify-between items-center mt-4">
          <button
            type="button"
            onClick={() => setInactive(false)}
            className="bg-yellow-400 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded-lg transition-all"
            disabled={!inactive}
          >
            Edit
          </button>

          <button
            type="submit"
            className="bg-[#00B4D8] hover:bg-[#0077B6] text-white font-bold py-2 px-4 rounded-lg transition-all"
            disabled={inactive}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  )
}

export default Setting
